module.exports = __webpack_public_path__ + "static/img/4.49d9dd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/eng/4.png
// module id = iF5Z
// module chunks = 0